import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from '@app/app.routes';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { maintenanceInterceptor } from '@core/interceptors/maintenance.interceptor';
import { paymentRequiredInterceptor } from '@core/interceptors/payment-required.interceptor';
import { NavigationService } from '@services/navigation.service';
import { PosthogService } from '@services/posthog.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withXhr(),
      withInterceptors([authInterceptor, maintenanceInterceptor, paymentRequiredInterceptor])
    ),
    provideNativeDateAdapter(),
    provideAppInitializer(() => {
      inject(NavigationService);
      inject(PosthogService);
    }),
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 1000 } }
  ]
};
